import { render, staticRenderFns } from "./ContratoGet.vue?vue&type=template&id=2824568c&scoped=true"
import script from "./ContratoGet.vue?vue&type=script&lang=js"
export * from "./ContratoGet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2824568c",
  null
  
)

export default component.exports